module.exports = __webpack_public_path__ + "static/media/kriti.f0cb31a4.jpeg";